import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "space-y-4" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-1" }
const _hoisted_3 = { class: "text-neutral-400" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 border-t border-neutral-800 my-2" }, null, -1)
const _hoisted_5 = { class: "text-neutral-400" }
const _hoisted_6 = { class: "block" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Collapse attributes")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Expand for all attributes")

import { ChevronUpIcon, ChevronDownIcon } from "@heroicons/vue/24/outline";
import AppButton from "@/components/app/AppButton.vue";
import { computed, ref } from "vue";
import { useTimeAgo } from "@vueuse/core";
import { getShortAddress } from "@/utils/ethereum";


export default /*#__PURE__*/_defineComponent({
  __name: 'TokenData',
  props: ["token"],
  setup(__props) {

const props = __props


const collapse = ref(false);

const data = computed(() => ({
    Owner: getShortAddress(props.token?.owner?.id || ""),
    "Minted On": useTimeAgo(props.token?.createdAtTimestamp * 1000).value,
}));

const attributes = computed(() => props.token?.metadata?.attributes || []);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data), (value, key) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(key), 1),
          _createElementVNode("div", null, _toDisplayString(value), 1)
        ], 64))
      }), 128)),
      (collapse.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_4,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(attributes), (attribute, i) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(attribute.trait_type), 1),
                _createElementVNode("div", null, _toDisplayString(attribute.value), 1)
              ], 64))
            }), 128))
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createVNode(AppButton, {
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (collapse.value = !collapse.value), ["prevent"])),
      size: "xs",
      color: "transparent",
      class: "!p-0"
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_6, [
          (collapse.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_7
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_8
              ], 64))
        ]),
        (collapse.value)
          ? (_openBlock(), _createBlock(_unref(ChevronUpIcon), {
              key: 0,
              class: "w-2 h-2 block"
            }))
          : (_openBlock(), _createBlock(_unref(ChevronDownIcon), {
              key: 1,
              class: "w-2 h-2 block"
            }))
      ]),
      _: 1
    })
  ]))
}
}

})